"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createStyles = _interopRequireDefault(require("@material-ui/core/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var useStyles = (0, _makeStyles.default)(theme => (0, _createStyles.default)({
  radioCardContainer: {
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1)
    }
  },
  radioCard: {
    padding: theme.spacing(1),
    margin: 0,
    border: "1px solid ".concat(theme.palette.divider),
    borderRadius: '5px'
  },
  activeRadioCard: {
    backgroundColor: theme.palette.primary.main + '1A',
    border: "1px solid ".concat(theme.palette.primary.main)
  },
  paymentOptionContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  paymentIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary
  },
  blueText: {
    color: theme.palette.primary.main
  }
}), {
  name: 'RadioCard'
});
var _default = exports.default = useStyles;